import { IS_LOGIN } from './types';

const updateLoginStatus = () => {
    const isAdminLogin = localStorage.getItem('auth_token') ? (localStorage.getItem('auth_token').length ? true: false): false ;
    return dispatch => {
        dispatch(
            {
              type: IS_LOGIN,
              payload: isAdminLogin,  
            }
        )
    }
}








export {
    updateLoginStatus,
}